import styled from "styled-components";
import { fontWeights } from "styles/fonts";

export const PeakInfoGroup = styled.g`
  > text {
    font-size: 14px;

    &.bold {
      font-weight: ${fontWeights.bold};
    }
  }
`;
